import React, { useState } from 'react';
import '../css/FranchiseHub.css';

const FranchiseHub = () => {
  const [franchiseData, setFranchiseData] = useState({
    name: '',
    mobile: '',
    email: '',
    city: '',
    budget: '',
    message: ''
  });

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFranchiseData(prev => ({ ...prev, [name]: value }));
  };

  const handleFormSubmit = (e) => {
    e.preventDefault();
    console.log('Franchise Lead Application Received:', franchiseData);
    alert('Bhai, your Franchise Enquiry has been submitted successfully! Our team will connect with you shortly.');
  };

  return (
    <section className="gfi-franchise-hub-section">
      
      {/* ==========================================================================
          TOP MASTER BLUE HEADER STRIP (Screenshot 19.JPG Top Section)
         ========================================================================== */}
      <div className="gfi-franchise-top-banner">
        <div className="gfi-franchise-banner-content">
          <span className="gfi-franchise-tag-badge">— FRANCHISE OPPORTUNITY 2026</span>
          <h1 className="gfi-franchise-main-title">
            Franchise Opportunity – Start Your Own<br />Fire & Safety Training Institute in India
          </h1>
          <p className="gfi-franchise-subtitle">
            Growth Academy Pvt. Ltd. offers a profitable Franchise Opportunity in Fire & Safety Training for 
            entrepreneurs, educators, and business-minded individuals across India.
          </p>
        </div>
      </div>

      {/* ==========================================================================
          BOTTOM ASYMMETRICAL COLUMN CONTENT SHIELD MESH 
         ========================================================================== */}
      <div className="gfi-franchise-body-container">
        <div className="gfi-franchise-layout-grid">
          
          {/* LEFT SIDE: INFORMATIVE MATRICES CARDS */}
          <div className="gfi-franchise-info-stack">
            
            {/* CARD 1: TECHNICAL INTRODUCTION CARD */}
            <div className="gfi-franchise-content-card">
              <div className="gfi-franchise-card-meta-head">
                <span className="gfi-franchise-dash-line">—</span>
                <span className="gfi-franchise-card-lbl-node">📍 INTRODUCTION</span>
              </div>
              <p className="gfi-franchise-p-text">
                Growth Academy Pvt. Ltd. offers a profitable Franchise Opportunity in Fire & Safety Training 
                for entrepreneurs, educators, and business-minded individuals across India.
              </p>
              <p className="gfi-franchise-p-text">
                With 16+ years of experience, 10,000+ trained students, and a strong presence in Bihar and 
                Uttar Pradesh, we provide a proven business model in the fast-growing field of Industrial 
                Safety & HSE (Health, Safety & Environment) education.
              </p>
              <div className="gfi-franchise-action-highlight">
                👉 <span className="gfi-franchise-highlight-link">Start your own institute and build a successful career in the education and safety training industry.</span>
              </div>
            </div>

            {/* CARD 2: VALUE PROPOSITION COMPLIANCE CHECKLIST */}
            <div className="gfi-franchise-content-card">
              <div className="gfi-franchise-card-meta-head">
                <span className="gfi-franchise-dash-line">—</span>
                <span className="gfi-franchise-card-lbl-node">🎯 WHY CHOOSE US</span>
              </div>
              <h3 className="gfi-franchise-inner-card-title">Why Choose Growth Academy Franchise</h3>
              
              <div className="gfi-franchise-checklist-grid">
                
                <div className="gfi-franchise-check-item">
                  <span className="gfi-franchise-check-dot">✓</span>
                  <span className="gfi-franchise-check-txt">Established brand in Fire & Safety training</span>
                </div>

                <div className="gfi-franchise-check-item">
                  <span className="gfi-franchise-check-dot">✓</span>
                  <span className="gfi-franchise-check-txt">High-demand courses (NEBOSH, IOSH, Industrial Safety)</span>
                </div>

                <div className="gfi-franchise-check-item">
                  <span className="gfi-franchise-check-dot">✓</span>
                  <span className="gfi-franchise-check-txt">Proven business model with continuous student demand</span>
                </div>

                <div className="gfi-franchise-check-item">
                  <span className="gfi-franchise-check-dot">✓</span>
                  <span className="gfi-franchise-check-txt">Strong placement support system</span>
                </div>

                <div className="gfi-franchise-check-item">
                  <span className="gfi-franchise-check-dot">✓</span>
                  <span className="gfi-franchise-check-txt">Complete academic & operational guidance</span>
                </div>

                <div className="gfi-franchise-check-item">
                  <span className="gfi-franchise-check-dot">✓</span>
                  <span className="gfi-franchise-check-txt">Marketing and lead generation support</span>
                </div>

              </div>
            </div>

          </div>

          {/* RIGHT SIDE: ELEVATED LEAD ENQUIRY CAPTURE SYSTEM */}
          <div className="gfi-franchise-form-sidebar">
            <div className="gfi-franchise-form-elevated-card">
              
              <div className="gfi-franchise-form-top-meta">
                <span className="gfi-franchise-form-dash">— FRANCHISE ENQUIRY</span>
                <h3 className="gfi-franchise-form-title">Apply for Franchise Opportunity</h3>
              </div>

              <form onSubmit={handleFormSubmit} className="gfi-franchise-form-node">
                
                <div className="gfi-franchise-input-group">
                  <label>Name</label>
                  <input 
                    type="text" 
                    name="name" 
                    placeholder="Your Name" 
                    value={franchiseData.name} 
                    onChange={handleInputChange} 
                    required 
                  />
                </div>

                <div className="gfi-franchise-input-group">
                  <label>Mobile Number</label>
                  <input 
                    type="tel" 
                    name="mobile" 
                    placeholder="Mobile Number" 
                    value={franchiseData.mobile} 
                    onChange={handleInputChange} 
                    required 
                  />
                </div>

                <div className="gfi-franchise-input-group">
                  <label>Email</label>
                  <input 
                    type="email" 
                    name="email" 
                    placeholder="Email Address" 
                    value={franchiseData.email} 
                    onChange={handleInputChange} 
                    required 
                  />
                </div>

                <div className="gfi-franchise-input-group">
                  <label>City</label>
                  <input 
                    type="text" 
                    name="city" 
                    placeholder="Your City" 
                    value={franchiseData.city} 
                    onChange={handleInputChange} 
                    required 
                  />
                </div>

                <div className="gfi-franchise-input-group">
                  <label>Investment Budget</label>
                  <select name="budget" value={franchiseData.budget} onChange={handleInputChange} required>
                    <option value="">Select Budget</option>
                    <option value="5-10-lakhs">INR 5 Lakhs - 10 Lakhs</option>
                    <option value="10-20-lakhs">INR 10 Lakhs - 20 Lakhs</option>
                    <option value="20-plus-lakhs">INR 20 Lakhs +</option>
                  </select>
                </div>

                <div className="gfi-franchise-input-group">
                  <label>Message</label>
                  <textarea 
                    name="message" 
                    rows="3" 
                    placeholder="Additional details" 
                    value={franchiseData.message} 
                    onChange={handleInputChange}
                  ></textarea>
                </div>

                <button type="submit" className="gfi-franchise-submit-trigger">
                  Submit Enquiry
                </button>

              </form>

            </div>
          </div>

        </div>
      </div>

    </section>
  );
};

export default FranchiseHub;